module.exports = __webpack_public_path__ + "static/media/img1.2bf539a2.png";